import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applySeo, SITE_NAME } from '../../utils/seo';
import { initAnalytics, trackPageView } from '../../utils/analytics';

// Pages that set their own SEO (home, listing, product) are skipped here.
const SELF_MANAGED = [/^\/$/, /^\/all-product/, /^\/product\//];
const PRIVATE = ['/cart', '/checkout', '/account', '/auth', '/admin', '/order-success', '/wishlist', '/wallet', '/profile'];
const STATIC_PAGES = {
  '/about-us': ['About Mithralaya', 'Mithralaya is a Chennai store for sarees, kurtis, churidar sets and kidswear, delivered across India.'],
  '/faqs': ['Frequently asked questions', 'Answers about orders, delivery, cash on delivery, returns, refunds and sizing at Mithralaya.'],
  '/return-refunds': ['Returns & refunds', 'How to return an item within 7 days of delivery and how refunds work at Mithralaya.'],
  '/privacy-policy': ['Privacy policy', 'How Mithralaya collects, uses and protects your personal information.'],
  '/terms-conditions': ['Terms & conditions', 'Terms of use for shopping at Mithralaya.'],
  '/contact': ['Contact us', 'Call, email or visit Mithralaya in Chennai for help with orders, sizing and returns.'],
  '/track-order': ['Track your order', 'Track your Mithralaya order with your order ID and phone number.'],
  '/sell-with-us': ['Sell with us', 'Partner with Mithralaya to sell your sarees and ethnic wear.']
};

// Sets SEO for simple pages, and sends a page view on every route change
const RouteSeo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    if (!SELF_MANAGED.some((re) => re.test(pathname))) {
      if (PRIVATE.some((p) => pathname === p || pathname.startsWith(`${p}/`))) {
        applySeo({ title: SITE_NAME, robots: 'noindex, nofollow' });
      } else if (STATIC_PAGES[pathname]) {
        const [t, d] = STATIC_PAGES[pathname];
        applySeo({ title: `${t} | ${SITE_NAME}`, description: d });
      } else {
        applySeo({ title: `Page not found | ${SITE_NAME}`, robots: 'noindex, follow' });
      }
    }
    // give pages a moment to set their title before the page view is sent
    const t = setTimeout(() => trackPageView(pathname), 400);
    return () => clearTimeout(t);
  }, [pathname]);

  return null;
};

export default RouteSeo;
